import { useSelector, useDispatch } from 'react-redux';

import app from 'app/config/app';
import FilterValues from 'core/filter/FilterValues';
import { deleteFilterParams } from 'app/features/customer-kycs/customerKycSlice';

export default function CustomerKycFilterValues() {
  const dispatch = useDispatch();

  const { params } = useSelector((state) => state.customerKycs.index);

  const handleOnRemoveFilter = (key) => {
    dispatch(deleteFilterParams(key));
  };

  return (
    <FilterValues
      value={params}
      onRemoveFilter={handleOnRemoveFilter}
      ignoreKeys={[...app.ignoreFilterKeys, 'partner_id', 'user_id']}
    />
  );
}
